/**
 * v3_report_entries.source_documents is the only citation field.
 * JSONB may be a list or a wrapper `{ sources: [...] }` (normalized by the API too).
 */

/**
 * @param {unknown} raw — column value from API or DB-shaped JSON
 * @returns {unknown[]}
 */
export function normalizeSourceDocumentsPayload(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'object' && raw !== null && Array.isArray(raw.sources)) return raw.sources;
  return [];
}

/**
 * @param {{ source_documents?: unknown }} app
 * @returns {unknown[]}
 */
export function getApplicationSourceItems(app) {
  return normalizeSourceDocumentsPayload(app?.source_documents);
}

/** @param {unknown} o */
export function isStructuredSourceDoc(o) {
  return (
    o &&
    typeof o === 'object' &&
    typeof o.signed_url === 'string' &&
    o.signed_url.trim().length > 0
  );
}

/**
 * Collapse sorted unique page numbers into contiguous ranges for display/links.
 * @param {unknown[]} pages
 * @returns {{ from: number, to: number }[]}
 */
export function pagesToLinkRanges(pages) {
  const nums = [...new Set((pages || []).map((p) => Number(p)).filter((n) => Number.isFinite(n) && n >= 1))].sort(
    (a, b) => a - b
  );
  if (!nums.length) return [];
  const ranges = [];
  let from = nums[0];
  let to = nums[0];
  for (let i = 1; i < nums.length; i++) {
    if (nums[i] === to + 1) {
      to = nums[i];
    } else {
      ranges.push({ from, to });
      from = to = nums[i];
    }
  }
  ranges.push({ from, to });
  return ranges;
}

/**
 * PDF in-browser: fragment `#page=N` (1-based) works in common viewers (e.g. Chrome).
 * @param {string} signedUrl
 * @param {number} page 1-based
 */
export function pdfUrlWithPage(signedUrl, page) {
  if (!signedUrl || page == null || !Number.isFinite(page)) return '#';
  const base = String(signedUrl).trim().split('#')[0];
  return `${base}#page=${Math.max(1, Math.floor(page))}`;
}
